import React from 'react';
import {
  Avatar,
  Button,
  Chip,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@material-ui/core';
import img_avatar from '../../../static/img/img_avatar.png';
import { Link } from 'react-router-dom';
import auth from '../../../auth/authService';
import { ROLES } from '../../../utils/constants';

const DetailsProfile = ({ data }) => {
  return (
    <Paper className='paper main-paper'>
      <div className='main-paper__content'>
        <div className='main-paper__content_avatar'>
          <Avatar alt={data.fullname} src={img_avatar} className='img' />
        </div>
        <div className='main-paper__content_name'>{data.name}</div>
      </div>
      <List component='nav' aria-label='roles' className='main-paper__data'>
        <ListItem className='data__roles'>
          {data.roles.map((role) =>
            data.selectedRole === role.id ? (
              <Chip
                label={role.display_name}
                key={role.id}
                color='primary'
                style={{ margin: '0.25em' }}
              />
            ) : (
              <Chip
                label={role.display_name}
                key={role.id}
                style={{ marginRight: '0.5em' }}
              />
            )
          )}
        </ListItem>
        <ListItem divider>
          <ListItemText primary='Proyectos:' />
          <Chip label={data.projects.length} color='primary' />
        </ListItem>
        <ListItem divider>
          <ListItemText primary='Grupos:' />
          <Chip label={data.groups.length} color='primary' />
        </ListItem>
        <ListItem divider>
          <ListItemText
            primary='Cédula:'
            secondary={data.identification_card}
          />
        </ListItem>
        <ListItem divider>
          <ListItemText primary='Nombre:' secondary={data.fullname} />
        </ListItem>
        <ListItem>
          <ListItemText primary='E-mail:' secondary={data.email} />
        </ListItem>

        {auth.getSelectedRole().name === ROLES.CIMOGSYS && (
          <Link to={`/usuario/${data.id}`} className='link'>
            <Button
              variant='contained'
              color='primary'
              className='btn btn-guardar '
            >
              Editar
            </Button>
          </Link>
        )}
      </List>
    </Paper>
  );
};

export default DetailsProfile;
